import { ApiResponse, TokenData } from "../models";
import { ProductTypeInterested } from "../models/productTypeInterested";

import * as http from "./http";
import ApiService from "./service";

export class ProductTypeInterestedService extends ApiService {
  public async loadAllProductTypeInterested() {
    const url = `${this.apiDomain}/api/product-type-interested`;

    const resposne = await http.get<ApiResponse<ProductTypeInterested[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createProductTypeInterested(data: ProductTypeInterested) {
    const url = `${this.apiDomain}/api/product-type-interested`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateProductTypeInterested(
    data: ProductTypeInterested,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/product-type-interested/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteProductTypeInterested(id?: string) {
    const url = `${this.apiDomain}/api/product-type-interested/${id}`;

    const response = await http.remove<ApiResponse<ProductTypeInterested>>(
      url,
      this.store
    );
    return response.data;
  }
}
